import { ref } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'CurrencyModal',
  props: {
    visible: {
      default: false,
      type: Boolean
    },
    currency: {
      default: '',
      type: String
    }
  },
  emits: ['okModal', 'closeModal'],
  setup(__props, {
    emit: emits
  }) {
    const props = __props;
    const useValue = ref('US');
    const handleBtn = value => {
      switch (value) {
        case 'ok':
          emits('okModal', useValue.value, true);
          break;
        case 'cancel':
          useValue.value = 'US';
          emits('closeModal');
          break;
      }
    };
    return (_ctx, _cache) => {
      const _component_a_radio = _resolveComponent("a-radio");
      const _component_a_radio_group = _resolveComponent("a-radio-group");
      const _component_a_modal = _resolveComponent("a-modal");
      return _openBlock(), _createBlock(_component_a_modal, {
        open: props.visible,
        title: "请选择导出商品价格币种",
        centered: "",
        onOk: _cache[1] || (_cache[1] = $event => handleBtn('ok')),
        class: "currency-modal",
        onCancel: _cache[2] || (_cache[2] = $event => handleBtn('cancel'))
      }, {
        default: _withCtx(() => [_createVNode(_component_a_radio_group, {
          value: useValue.value,
          "onUpdate:value": _cache[0] || (_cache[0] = $event => useValue.value = $event)
        }, {
          default: _withCtx(() => [_createVNode(_component_a_radio, {
            value: 'US'
          }, {
            default: _withCtx(() => [_createTextVNode("USD(美国)")]),
            _: 1
          }), _createVNode(_component_a_radio, {
            value: props.currency
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(props.currency) + "(默认币种)", 1)]),
            _: 1
          }, 8, ["value"])]),
          _: 1
        }, 8, ["value"])]),
        _: 1
      }, 8, ["open"]);
    };
  }
});